import { CardMedia, Typography } from '@mui/material'
import { ReactNode } from 'react'
import { getBookCoverImage, getBookInitialsFromName } from 'src/@core/utils/functions'
import { BookData } from 'src/@core/utils/types'

export type BookCoverImage = {
  book: BookData
  onClick?: () => any
  children?: ReactNode
  hoverEffect?: boolean
  key?: any
}

const BookCoverImage = ({ book, onClick, children, hoverEffect = true }: BookCoverImage) => {
  return (
    <CardMedia
      onClick={onClick}
      image={getBookCoverImage(book)}
      sx={({ breakpoints }) => ({
        minWidth: 124,
        minHeight: 194,
        maxWidth: 124,
        maxHeight: 194,
        [breakpoints.down('md')]: { minWidth: 102, minHeight: 160, maxWidth: 102, maxHeight: 160 },
        backgroundSize: book.coverImage ? 'contain' : 'auto',
        backgroundColor: 'black',
        borderRadius: 1,
        ...(hoverEffect && {
          cursor: 'pointer',
          '&:hover': {
            opacity: 0.5
          }
        })
      })}
    >
      <Typography textAlign={'center'} sx={{ fontSize: '6rem', color: 'grey' }}>
        {!book.coverImage && getBookInitialsFromName(book.title)}
        {children}
      </Typography>
    </CardMedia>
  )
}

export default BookCoverImage
